import { atLeast } from '../utils/breakpoints';
import { fadeOut, swing } from '../utils/animate';
import { ready } from '../utils/ready';

import toggler from './toggler';
import menu from './menu';
import menuContrast from './menuContrast';
import fadeInvisible from './fadeInvisible';
import videos from './videos';
import sliders from './sliders';
import siteNavigation from './siteNavigation';
import scrollKeyframes from './scrollKeyframes';
import newsletter from './newsletter';
import introAnimation from './introAnimation';

// jQuery's fadeOut('500'): an unknown speed string, so jQuery's default 400ms.
const LOADER_FADE = 400;
// Longest wait for the `load` event after the DOM is ready: images or videos that
// never finish loading (e.g. from the old domain) would keep the loader up.
const LOADER_MAX_WAIT = 2000;

// Page loader (#loader, pages other than home): fades out once the page has
// loaded (at most LOADER_MAX_WAIT after the DOM is ready), or when clicked;
// then body gets .loaded.
function loader() {
    let done = false;
    const hide = () => {
        if (done) return;
        done = true;
        const el = document.getElementById('loader');
        if (el) fadeOut(el, LOADER_FADE).then(() => document.body.classList.add('loaded'));
    };
    if (document.readyState === 'complete') {
        hide();
    } else {
        window.addEventListener('load', hide);
        setTimeout(hide, LOADER_MAX_WAIT);
    }

    document.getElementById('loader')?.addEventListener('click', () => {
        fadeOut(document.getElementById('loader'), LOADER_FADE);
    });
}

// Share links open in a small popup window.
function shareButtons() {
    document.querySelectorAll('a.sharing-btn').forEach((link) => link.addEventListener('click', (e) => {
        e.preventDefault();
        window.open(link.href, 'share-dialog', 'width=626,height=436');
    }));
}

// Newsletter form in the menu (from medium up): toggled by its link/close button.
function newsletterToggle() {
    if (!atLeast('medium')) return;
    document.querySelectorAll('.newsletter-toggle a, .newsletter-close').forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('top-menu')?.classList.toggle('newsletter-expanded');
    }));
}

// Same-page links (#id) scroll smoothly to their target (500ms, swing).
function scrollTo(top, duration = 500) {
    const from = window.scrollY, start = performance.now();
    const step = (now) => {
        const t = Math.min((now - start) / duration, 1);
        window.scrollTo(0, from + (top - from) * swing(t));
        if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}

// "Go back" buttons without a real link (newsletter, film pages).
function backButtons() {
    document.querySelectorAll('a.go-back-btn[href="#"]').forEach((link) => link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.history.back();
    }));
}

function anchorLinks() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (e) => {
        e.preventDefault();
        const id = link.getAttribute('href').slice(1);
        const target = id && document.getElementById(id);
        if (target) scrollTo(target.getBoundingClientRect().top + window.scrollY);
    }));
}

ready(() => {
    toggler();
    loader();
    shareButtons();
    newsletterToggle();
    siteNavigation();
    menuContrast();
    menu();
    sliders();
    fadeInvisible();
    videos();
    introAnimation();
    scrollKeyframes();
    newsletter();
    backButtons();
    anchorLinks();
});
